export const CSV_BILL_NAME = 'CsvBill';
export const HOME_NAME = 'home';
